import { render, staticRenderFns } from "./ExpulsionOrderEdit.vue?vue&type=template&id=171299cf&"
import script from "./ExpulsionOrderEdit.vue?vue&type=script&lang=ts&"
export * from "./ExpulsionOrderEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports